import { Card, RenderControl, Table, Span } from '@fareye/ui'
import { useTranslation } from '@fareye/common'
import { isEmpty, cancelToken, get, getQueryParams } from '@fareye/utils'
import React from 'react'
import { IPageConfig, TAlertChildrenConfig } from '../..'
import { getTableColumns } from './Column'
import { IApiFilter } from '@fareye/types'
// import { IPageConfig } from '../../utility/types'

interface ISubscriptionListing {
  subscriptionType: string
  selectedAlert: any
  setSelectedAlert(val: any): void
  editingAlert?: any
  setEditingAlert?(val: any): void
  alertChildrenConfig: TAlertChildrenConfig
  selectAlertLabel: string
  isRadio?: boolean
  isReload?: boolean
}

export const SubscriptionListing = React.memo(
  ({
    subscriptionType,
    selectedAlert,
    setSelectedAlert,
    editingAlert,
    setEditingAlert,
    alertChildrenConfig,
    selectAlertLabel,
    isRadio,
    isReload
  }: ISubscriptionListing) => {
    // TODO : Columns to be passed only from unique prop
    const [apiData, setData] = React.useState<any>({
      data: [],
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: '',
      selectedColumns: []
    })
    const [pageNo, setPageNo] = React.useState(0)
    const [recordsPerPage, setRecordsPerPage] = React.useState(10)
    const { listAlert, deleteAlert } = alertChildrenConfig

    const source = cancelToken().source()
    const { t } = useTranslation()
    React.useEffect(() => {
      fetchSubscriptionData()
      setPageNo(0)
    }, [subscriptionType])

    React.useEffect(() => {
      if (isReload) {
        fetchSubscriptionData()
      }
    }, [selectedAlert])

    function onPageSizeChange(pageSize: number) {
      setRecordsPerPage(pageSize)
    }
    async function fetchSubscriptionData() {
      setData({
        ...apiData,
        data: [],
        isLoading: true
      })
      try {
        const { apiURL } = (listAlert as IPageConfig).config
          .apiConfig as IApiFilter
        const queryParams = getQueryParams({ type: subscriptionType })
        const url = `${apiURL}?${queryParams}`
        const { data } = await get(url, source.token)
        //FIXME: is_active :null is active subscription Remove this once handle by backend.
        const filteredData = data.results.filter(
          (ele: any) => ele.is_active !== false
        )
        let columns = []
        if (isRadio) {
          columns.push('radio')
        }
        columns = [
          ...columns,
          'users',
          ...data.meta.settings_visible_attr[subscriptionType],
          'providers',
          'is_consolidated'
        ]
        if (!isRadio) {
          columns.push('enableDisable')
        }
        setData({
          ...apiData,
          data: filteredData,
          selectedColumns: columns,
          isLoading: false,
          isSuccess: true,
          message: isEmpty(filteredData) ? 'No Data Found' : ''
        })
      } catch (ex:any) {
        setData({
          ...apiData,
          data: [],
          isLoading: false,
          message: 'No Data Found....'
        })
        console.error(ex)
      }
    }
    const { data, selectedColumns } = apiData

    return (
      <Card
        bg="#fff"
        header={
          <Span
            p={7}
            variant="h6"
            style={{ color: 'black', fontWeight: '600' }}
          >
            {t(`Saved Settings For ${selectAlertLabel}`)}
          </Span>
        }
      >
        <RenderControl state={apiData} style={{ padding: '0.5em' }} t={t}>
          <div
            style={{
              overflow: 'hidden'
            }}
          >
            {data.length && (
              <>
                <Table
                  data={data}
                  columns={getTableColumns(
                    selectedColumns,
                    selectedAlert,
                    setSelectedAlert,
                    {
                      t,
                      deleteAlert,
                      setEditingAlert
                    }
                  )}
                  className="striped responsive"
                  onPageChange={(pageIndex: number) => setPageNo(pageIndex)}
                  totalElements={data.length}
                  defaultPageSize={recordsPerPage}
                  defaultPageIndex={pageNo}
                  onPageSizeChange={onPageSizeChange}
                  t={t}
                  getTrProps={(row: any) => {
                    const background =
                      row.original.id === selectedAlert?.id
                        ? '#e6eff4'
                        : '#FFFFFF'
                    return {
                      ...(isRadio
                        ? { onClick: () => setSelectedAlert(row.original) }
                        : {}),
                      style: { background }
                    }
                  }}
                />
              </>
            )}
          </div>
        </RenderControl>
      </Card>
    )
  }
)
